import React from "react";
import { TouchableWithoutFeedback } from "react-native";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components/native";
import { localize } from "cci-utility";
import Icon from "../icon/FontAwesomePro";
import Label from "./Label";
import { Container } from "../layout/common";

const Checkbox = props => {
  const { intl, labelMargins, disabled, fontColor, backgroundColor } = props,
    checked = props.value === true,
    // Process labels as a string (if specified as such) or a react-intl message (for translation).
    leftLabel = localize(intl, props.leftLabel),
    rightLabel = localize(intl, props.rightLabel);

  return (
    <TouchableWithoutFeedback
      onPress={() => props.onPress(!checked)}
      disabled={disabled}
    >
      <Container flexDirection="row" alignItems="center" {...props}>
        {/* Label that goes to the left of the checkbox icon */}
        {leftLabel && (
          <Label margins={labelMargins || "0 7px 0 0"} color={fontColor}>
            {leftLabel}
          </Label>
        )}

        <Icon
          name={checked === true ? "check-square" : "square"}
          color={fontColor || props.theme.fontColor}
          iconSize={20}
          backgroundColor={!disabled ? backgroundColor || props.theme.fieldBackgroundColor : undefined}
        />

        {/* Label that goes to the right of the checkbox icon */}
        {rightLabel && (
          <Label margins={labelMargins || "0 0 0 7px"} color={fontColor}>
            {rightLabel}
          </Label>
        )}
      </Container>
    </TouchableWithoutFeedback>
  );
};

export default injectIntl(withTheme(Checkbox));
